module.exports = __webpack_public_path__ + "media/images/bg-masthead-c4526c7bdac65f8c793c1c306192d793.jpg";